import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import { useTranslation } from 'react-i18next';

type Props = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ConfirmEquipmentSwitchDialog = ({ open, onCancel, onConfirm }: Props) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{t('actions.confirm')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('pages.accessories.confirm-switch-equipment')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          {t('actions.cancel')}
        </Button>
        <Button onClick={onConfirm} color="primary" autoFocus>
          {t('actions.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmEquipmentSwitchDialog;
